import { Pipe } from '@angular/core';
import { isArray } from '../utils/utils';
var MapPipe = (function () {
    function MapPipe() {
    }
    MapPipe.prototype.transform = function (input, fn) {
        if (!isArray(input) || !fn) {
            return input;
        }
        return input.map(fn);
    };
    return MapPipe;
}());
export { MapPipe };
MapPipe.decorators = [
    { type: Pipe, args: [{
                name: 'map'
            },] },
];
/** @nocollapse */
MapPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=map.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/array/map.pipe.js
// module id = 241
// module chunks = 103